import React, { useEffect, useMemo, useState } from 'react';
import { LatexText, onizlemeKes } from './SoruKarti';

// UZMAN SETİ — 2027 TYT Problemler (MEB_2018, 9.3.5.x) 200 soru. Yalnız super_admin
// görür (backend: GET /api/sorular/uzman-set rolKontrol + izole sorular_uzman tablosu).
// Hedefler onaylı belirtke tablosundan (referans/uzman_problem_2027/belirtke.json; kullanıcı onayı 2026-10-16).
export const HEDEF = {
  '9.3.5.1': { ad: 'Oran-orantı', adet: 14 },
  '9.3.5.2': { ad: 'Denklem / eşitsizlik kurma', adet: 25 },
  '9.3.5.3': { ad: 'Kesir', adet: 12 },
  '9.3.5.4': { ad: 'Yaş', adet: 14 },
  '9.3.5.5': { ad: 'İşçi / havuz', adet: 12 },
  '9.3.5.6': { ad: 'Yüzde, kâr-zarar', adet: 24 },
  '9.3.5.7': { ad: 'Karışım', adet: 12 },
  '9.3.5.8': { ad: 'Hız-hareket', adet: 21 },
  '9.3.5.9': { ad: 'Rutin olmayan', adet: 35 },
  '9.3.5.10': { ad: 'Sayı', adet: 31 },
};
const ZORLUK_HEDEF = { kolay: 20, orta: 50, zor: 30 }; // yüzde
const HARFLER = ['A', 'B', 'C', 'D', 'E'];
const DURUM_RENK = {
  onaylandi: 'bg-green-100 text-green-800',
  reddedildi: 'bg-red-100 text-red-800',
  onay_bekliyor: 'bg-yellow-100 text-yellow-800',
};
// Kazanım sırası: sayısal parça karşılaştırması (9.3.5.2 < 9.3.5.10; MAT.8.1.2 < MAT.8.2.2).
// Önceki "son parça" sıralaması LGS kodlarında farklı temaları eşit sayıyordu.
export const kodKarsilastir = (a, b) => String(a).localeCompare(String(b), 'tr', { numeric: true });

// Set paneli ayarı. Varsayılan Uzman Seti; LGS Seti (LgsSeti.js) kendi ayarıyla aynı paneli kullanır.
export const UZMAN_AYAR = {
  endpoint: '/api/sorular/uzman-set',
  hedef: HEDEF,
  harfler: HARFLER,
  baslik: '🎓 Uzman Seti — 2027 TYT Problemler',
  altBaslik: 'MEB 2018 · yalnız süperadmin',
  figurEtiket: 'Figürlü (hedef ~%60)',
  bosMetin: 'Henüz soru yok. Üretim: /soru-uret-uzman-problem',
  renk: { satir: 'bg-violet-50', dugme: 'bg-violet-700', cubuk: 'bg-violet-500' },
};

export function ozetle(sorular) {
  const canli = sorular.filter((s) => s.durum !== 'reddedildi');
  const say = (dizi, f) => dizi.reduce((m, s) => { const k = f(s); m[k] = (m[k] || 0) + 1; return m; }, {});
  return {
    canli: canli.length,
    durum: say(sorular, (s) => s.durum),
    kazanim: say(canli, (s) => s.kazanim_kodu),
    onayli: say(sorular.filter((s) => s.durum === 'onaylandi'), (s) => s.kazanim_kodu),
    harf: say(canli, (s) => s.dogru_cevap),
    zorluk: say(canli, (s) => s.zorluk),
    figurlu: canli.filter((s) => s.figurlu).length,
  };
}

const yuzde = (n, t) => (t ? Math.round((100 * n) / t) : 0);

// Tablo satırları = hedefteki kazanımlar ∪ veride görülen kazanımlar (2026-10-20: pilottan sonra
// üretilen MAT.8 soruları tabloda ve süzgeçte görünmüyordu). Hedef dışı satırda adet null.
export function kazanimSatirlari(hedef, sorular) {
  const satir = Object.fromEntries(Object.entries(hedef).map(([k, h]) => [k, { ad: h.ad, adet: h.adet }]));
  for (const s of sorular) {
    if (s.kazanim_kodu && !satir[s.kazanim_kodu]) satir[s.kazanim_kodu] = { ad: s.alt_konu || s.konu || '', adet: null };
  }
  return Object.entries(satir).sort((a, b) => kodKarsilastir(a[0], b[0]));
}

// Basım için uygun: onaylı ve 1 puan değil (Basım'ın kendi süzgeciyle aynı).
export const basilabilir = (s) => s.durum === 'onaylandi' && Number(s.zorluk_puan) !== 1;

// Basım numara listesi (2026-10-17, kullanıcı isteği): işaretli her kazanımdan istenen adet,
// tohumlu karışık seçilir; liste kazanım sırasıyla, kazanım içinde öğretmen puanına göre
// kolaydan zora dizilir. secim = { '9.3.5.1': 3, … } → { nolar, idler, eksik: [{kod, istenen, var}] }
export function numaraSec(sorular, secim, tohum = 1) {
  let t = tohum >>> 0;
  const rastgele = () => { t = (t * 1664525 + 1013904223) >>> 0; return t / 4294967296; };
  const secilen = [];
  const eksik = [];
  Object.keys(secim).sort(kodKarsilastir).forEach((kod) => {
    const istenen = Number(secim[kod]) || 0;
    if (istenen <= 0) return;
    const aday = sorular.filter((s) => s.kazanim_kodu === kod && basilabilir(s))
      .map((s) => [rastgele(), s]).sort((a, b) => a[0] - b[0]).map((x) => x[1]);
    if (aday.length < istenen) eksik.push({ kod, istenen, var: aday.length });
    secilen.push(...aday.slice(0, istenen)
      .sort((a, b) => (Number(a.zorluk_puan) || 0) - (Number(b.zorluk_puan) || 0) || a.public_no - b.public_no));
  });
  return { nolar: secilen.map((s) => s.public_no), idler: secilen.map((s) => s.id), eksik };
}

export default function UzmanSeti({ apiUrl, authFetch, onGeri, onSoruSec, onBasimaGonder, ayar = UZMAN_AYAR }) {
  const HEDEF = ayar.hedef;
  const [sorular, setSorular] = useState([]);
  const [hata, setHata] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [kodSuz, setKodSuz] = useState('');
  const [durumSuz, setDurumSuz] = useState('');
  const [secim, setSecim] = useState({}); // kod -> adet (işaretli kazanımlar)
  const [tohum, setTohum] = useState(1);
  const [liste, setListe] = useState(null);
  const [kopyalandi, setKopyalandi] = useState(false);

  useEffect(() => {
    let iptal = false;
    (async () => {
      try {
        const r = await authFetch(`${apiUrl}${ayar.endpoint}`);
        const d = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(d.hata || `HTTP ${r.status}`);
        if (!iptal) setSorular(d.sorular || []);
      } catch (e) {
        if (!iptal) setHata(e.message);
      }
      if (!iptal) setYukleniyor(false);
    })();
    return () => { iptal = true; };
  }, [apiUrl, authFetch, ayar.endpoint]);

  const oz = useMemo(() => ozetle(sorular), [sorular]);
  const hedefToplam = Object.values(HEDEF).reduce((t, h) => t + h.adet, 0);
  const satirlar = useMemo(() => kazanimSatirlari(HEDEF, sorular), [HEDEF, sorular]);
  const gorunen = sorular.filter((s) => (!kodSuz || s.kazanim_kodu === kodSuz) && (!durumSuz || s.durum === durumSuz));
  const uygunSay = useMemo(() => sorular.filter(basilabilir)
    .reduce((m, s) => { m[s.kazanim_kodu] = (m[s.kazanim_kodu] || 0) + 1; return m; }, {}), [sorular]);
  const secimToplam = Object.values(secim).reduce((t, n) => t + (Number(n) || 0), 0);
  const isaretle = (kod, acik) => {
    setListe(null);
    setSecim((s) => {
      const y = { ...s };
      if (acik) y[kod] = Math.min(1, uygunSay[kod] || 0); else delete y[kod];
      return y;
    });
  };
  const adetYaz = (kod, deger) => {
    setListe(null);
    const n = Math.max(0, Math.min(uygunSay[kod] || 0, parseInt(deger, 10) || 0));
    setSecim((s) => ({ ...s, [kod]: n }));
  };
  const olustur = (yeniTohum) => {
    setKopyalandi(false);
    setTohum(yeniTohum);
    setListe(numaraSec(sorular, secim, yeniTohum));
  };
  const kopyala = async () => {
    try { await navigator.clipboard.writeText(liste.nolar.join(', ')); setKopyalandi(true); } catch (e) { setKopyalandi(false); }
  };

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        {!ayar.geriGizli && <button onClick={onGeri} className="text-blue-600 hover:text-blue-800 font-bold">&larr; Geri</button>}
        <h2 className="text-xl font-bold text-gray-800">{ayar.baslik}</h2>
        <span className="text-xs text-gray-500">{ayar.altBaslik}</span>
      </div>

      {yukleniyor ? (
        <div className="text-center text-gray-500 py-10">Yükleniyor…</div>
      ) : hata ? (
        <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">Set yüklenemedi: {hata}</div>
      ) : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
            <Kutu baslik="Toplam (red hariç)" deger={`${oz.canli} / ${hedefToplam}`} />
            <Kutu baslik="Onaylı" deger={oz.durum.onaylandi || 0} />
            <Kutu baslik="Onay bekliyor" deger={oz.durum.onay_bekliyor || 0} />
            <Kutu baslik={ayar.figurEtiket} deger={`${oz.figurlu} · %${yuzde(oz.figurlu, oz.canli)}`} />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
            <div className="lg:col-span-2 bg-white rounded-xl border border-gray-100 shadow-sm p-4">
              <h3 className="text-sm font-bold text-gray-700 mb-2">Kazanım kapsamı</h3>
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-xs text-gray-500 border-b">
                    <th className="py-1 w-6" title="Basım için seç" />
                    <th className="py-1">Kod</th><th>Alt konu</th><th className="text-right">Hedef</th>
                    <th className="text-right">Mevcut</th><th className="text-right">Onaylı</th>
                    <th className="text-right" title="Basıma alınacak soru sayısı">Basım adedi</th>
                  </tr>
                </thead>
                <tbody>
                  {satirlar.map(([kod, h]) => {
                    const n = oz.kazanim[kod] || 0;
                    const secili = kod in secim;
                    const durdur = (e) => e.stopPropagation();
                    return (
                      <tr key={kod} className={`border-b border-gray-50 cursor-pointer hover:bg-gray-50 ${secili ? ayar.renk.satir : ''}`}
                        onClick={() => setKodSuz(kodSuz === kod ? '' : kod)}>
                        <td className="py-1" onClick={durdur}>
                          <input type="checkbox" aria-label={`${kod} basım için seç`} checked={secili}
                            disabled={!uygunSay[kod]} onChange={(e) => isaretle(kod, e.target.checked)} />
                        </td>
                        <td className="py-1 font-mono text-xs">{kod}</td>
                        <td>{h.ad}</td>
                        <td className="text-right">{h.adet ?? <span className="text-gray-300" title="Belirtkede hedef yok">—</span>}</td>
                        <td className="text-right">
                          {/* İlerleme: hedefe ulaşan yeşil, eksik amber; hedefsiz satırda yalnız sayı. */}
                          <div className="flex items-center justify-end gap-1.5">
                            {h.adet != null && (
                              <div className="w-12 h-1.5 bg-gray-100 rounded" title={`${n}/${h.adet}`}>
                                <div className={`h-1.5 rounded ${n >= h.adet ? 'bg-green-500' : 'bg-amber-400'}`} style={{ width: `${Math.min(100, yuzde(n, h.adet))}%` }} />
                              </div>
                            )}
                            <span className={`font-semibold ${h.adet == null ? 'text-gray-800' : n >= h.adet ? 'text-green-700' : 'text-amber-700'}`}>{n}</span>
                          </div>
                        </td>
                        <td className="text-right">{oz.onayli[kod] || 0}</td>
                        <td className="text-right" onClick={durdur}>
                          <input type="number" min={0} max={uygunSay[kod] || 0} aria-label={`${kod} basım adedi`}
                            value={secili ? secim[kod] : ''} disabled={!secili}
                            onChange={(e) => adetYaz(kod, e.target.value)}
                            className="w-16 border rounded px-1 py-0.5 text-right disabled:bg-gray-50" />
                          <span className="text-xs text-gray-400 ml-1">/ {uygunSay[kod] || 0}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <div className="mt-3 border-t pt-3 text-sm" data-uzman-basim>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-semibold text-gray-700">Basım için numara listesi</span>
                  <span className="text-gray-500">{Object.keys(secim).length} kazanım · {secimToplam} soru</span>
                  <button type="button" disabled={secimToplam === 0} onClick={() => olustur(tohum)}
                    className={`ml-auto px-3 py-1 rounded ${ayar.renk.dugme} text-white text-xs disabled:opacity-40`}>Numaraları oluştur</button>
                  {liste && (
                    <button type="button" onClick={() => olustur(tohum + 1)} className="px-2 py-1 rounded border text-xs">↻ Farklı sorular</button>
                  )}
                </div>
                {liste && (
                  <div className="mt-2 space-y-2">
                    {liste.eksik.length > 0 && (
                      <div className="text-xs text-amber-700">
                        Yetersiz: {liste.eksik.map((e) => `${e.kod} (${e.var}/${e.istenen})`).join(', ')}
                      </div>
                    )}
                    <textarea readOnly value={liste.nolar.join(', ')} rows={3} aria-label="Soru numaraları"
                      className="w-full border rounded p-2 font-mono text-xs bg-gray-50" />
                    <div className="flex flex-wrap items-center gap-2">
                      <button type="button" onClick={kopyala} className="px-2 py-1 rounded border text-xs">
                        {kopyalandi ? '✓ Kopyalandı' : 'Kopyala'}
                      </button>
                      {onBasimaGonder && (
                        <button type="button" disabled={liste.idler.length === 0} onClick={() => onBasimaGonder(liste.idler)}
                          className="px-2 py-1 rounded bg-orange-600 text-white text-xs disabled:opacity-40">Basım'a gönder ({liste.idler.length})</button>
                      )}
                      <span className="text-xs text-gray-500">
                        Basım › Konu Testi › “Numara listesiyle doldur” kutusuna da yapıştırılabilir. Yalnız onaylı, 1 puan olmayan sorular seçilir.
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 space-y-4">
              <div>
                <h3 className="text-sm font-bold text-gray-700 mb-2">Cevap harfi</h3>
                {ayar.harfler.map((h) => (
                  <Cubuk key={h} etiket={h} n={oz.harf[h] || 0} toplam={oz.canli} renk={ayar.renk.cubuk} />
                ))}
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-700 mb-2">Zorluk (hedef 20/50/30)</h3>
                {Object.entries(ZORLUK_HEDEF).map(([z, hd]) => (
                  <Cubuk key={z} etiket={`${z} (%${hd})`} n={oz.zorluk[z] || 0} toplam={oz.canli} renk={ayar.renk.cubuk} />
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-3 text-sm">
            <select value={kodSuz} onChange={(e) => setKodSuz(e.target.value)} className="border rounded px-2 py-1">
              <option value="">Tüm kazanımlar</option>
              {satirlar.map(([kod, h]) => <option key={kod} value={kod}>{kod} · {h.ad}</option>)}
            </select>
            <select value={durumSuz} onChange={(e) => setDurumSuz(e.target.value)} className="border rounded px-2 py-1">
              <option value="">Tüm durumlar</option>
              <option value="onay_bekliyor">Onay bekliyor</option>
              <option value="onaylandi">Onaylı</option>
              <option value="reddedildi">Reddedildi</option>
            </select>
            <span className="text-gray-500">{gorunen.length} soru</span>
          </div>

          {sorular.length === 0 ? (
            <div className="text-center text-gray-400 py-10">{ayar.bosMetin}</div>
          ) : (
            <div className="space-y-2">
              {gorunen.map((s) => (
                <div key={s.id} role="button" tabIndex={0} onClick={() => onSoruSec(s.id)}
                  onKeyDown={(e) => { if (e.key === 'Enter') onSoruSec(s.id); }}
                  className="bg-white rounded-xl p-3 shadow-sm border border-gray-100 flex flex-wrap items-center gap-2 text-sm cursor-pointer hover:shadow-md hover:border-gray-300 transition-shadow">
                  <span className="font-mono text-xs bg-gray-800 text-white rounded px-1.5 py-0.5">#{s.public_no}</span>
                  <span className="font-mono text-xs text-gray-500">{s.kazanim_kodu}</span>
                  <span className="font-semibold text-gray-700">{s.alt_konu || s.konu}</span>
                  <span className="text-xs px-2 py-0.5 rounded bg-gray-100">{s.zorluk}</span>
                  <span className="text-xs px-2 py-0.5 rounded bg-gray-100">Cevap {s.dogru_cevap}</span>
                  {s.figurlu && <span className="text-xs px-2 py-0.5 rounded bg-sky-100 text-sky-800">figürlü</span>}
                  {s.zorluk_puan != null && <span className="text-xs px-2 py-0.5 rounded bg-indigo-100 text-indigo-800">puan {s.zorluk_puan}</span>}
                  <span className={`text-xs px-2 py-0.5 rounded-full ${DURUM_RENK[s.durum] || 'bg-gray-100 text-gray-700'}`}>{s.durum}</span>
                  <span className="ml-auto text-blue-600 text-xs">Detay ›</span>
                  {s.onizleme && (
                    <div className="basis-full text-xs text-gray-600 line-clamp-2">
                      <LatexText>{onizlemeKes(s.onizleme, 200)}</LatexText>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

function Kutu({ baslik, deger }) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-3">
      <div className="text-xs text-gray-500">{baslik}</div>
      <div className="text-lg font-bold text-gray-800">{deger}</div>
    </div>
  );
}

function Cubuk({ etiket, n, toplam, renk = 'bg-violet-500' }) {
  const y = yuzde(n, toplam);
  return (
    <div className="flex items-center gap-2 text-xs mb-1">
      <span className="w-20 text-gray-600">{etiket}</span>
      <div className="flex-1 h-2 bg-gray-100 rounded"><div className={`h-2 ${renk} rounded`} style={{ width: `${y}%` }} /></div>
      <span className="w-14 text-right text-gray-700">{n} · %{y}</span>
    </div>
  );
}
